import qs from 'qs'
import { CREAppByContextPayload, CREBannerByContextPayload } from './cre.types'
import axios from '../../utils/axios'

export function readCRE(id: number) {
  return axios({
    panelApi: true,
    method: 'GET',
    url: `/api/cre/public/${id}`,
  })
}

export function readCREAppByContext(payload: CREAppByContextPayload) {
  return axios({
    panelApi: true,
    method: 'GET',
    url: `/api/cre/app/context?${qs.stringify(payload, { encode: true })}`,
  })
}

export function readCREBannerByContext(payload: CREBannerByContextPayload) {
  return axios({
    skipChannel: true,
    panelApi: true,
    method: 'GET',
    url: `/api/cre/app/context?${qs.stringify(payload, { encode: true, arrayFormat: 'comma' })}`,
  })
}

export function readCREAppPreviewMode(id: string, language?: string) {
  const query = language ? `?${qs.stringify({ language }, { encode: true })}` : ''
  return axios({
    panelApi: true,
    method: 'GET',
    url: `/api/cre/app/preview/${id}${query}`,
  })
}
